export const FONT_MSDF = 'msdf';
export const FONT_BITMAP = 'bitmap';
